import { useAppSelector } from "@src/store/hooks";
import { HighlightedSectionEnum } from "@src/store/pricing/selectionSlice";

const useHighlightedSection = (data: HighlightedSectionEnum) => {
	const highlightedSection = useAppSelector((state) => state.pricing.selection.highlightedSection);
	return highlightedSection === data;
};

export default useHighlightedSection;
